export enum RepairStatus {
    New = 1,
    InProgress = 2,
    Closed = 3,
    Removed = 4,
    NotFinalized = 5
 
 }
 